import React, { useState} from 'react'
// , useEffect import { AiFillEye, AIFillEye, AiFillGithub } from 'react-icons/ai';
import { motion } from 'framer-motion';
import { images } from '../../constants';
import { AppWrap } from '../../wrapper';
// import { urlFor , client } from '../../client';
import './Work.scss';

const works = [
  {
    id: 'work-1',
    title: 'Modern UI/UX Website',
    description: 'A modern UI/UX website for a startup company.',
    imgUrl: images.about01,
    tags: ['UI/UX', 'Web Design', 'ReactJS'],
  },
  {
    id: 'work-2',
    title: 'Ewalle wallet app',
    description: 'Ewalle wallet app built with React Native.',
    imgUrl: images.about02,
    tags: ['Mobile App', 'React Native', 'UI/UX', 'Javascript'],
  },
  {
    id: 'work-3',
    title: 'Shareme Website',
    description: 'Beautiful pinterest-like website using React JS.',
    imgUrl: images.about03,
    tags: ['Web App', 'ReactJS', 'UI/UX', 'Javascript'],
  },
  {
    id: 'work-4',
    title: 'SpaceX',
    description: 'SpaceX CRUD API built with Node JS.',
    imgUrl: images.about04,
    tags: ['Backend App', 'Node JS'],
  },
  {
    id: 'work-5',
    title: 'Sweet Shop',
    description: 'An E-commerce app with beautiful UI/UX.',
    imgUrl: images.about04,
    tags: ['UI/UX', 'Mobile App', 'React Native', 'Javascript'],
  },
  {
    id: 'work-6',
    title: 'Community App',
    description: 'A community app built with React Native CLI.',
    imgUrl: images.about03,
    tags: ['Mobile App', 'React Native', 'UI/UX', 'Javascript'],
  },
  {
    id: 'work-7',
    title: 'Web3.0 Project',
    description: 'A web 3.0 app built with React JS & Solidity.',
    imgUrl: images.about02,
    tags: ['Web App', 'ReactJS', 'Solidity', 'Javascript'],
  },
  {
    id: 'work-8',
    title: 'MERN Memories',
    description: 'A MERN app built with React JS & MongoDB.',
    imgUrl: images.about01,
    tags: ['Web App', 'ReactJS', 'MongoDB', 'Javascript'],
  },
  // {
  //   id: 'work-9',
  //   title: 'Starbucks Clone',
  //   description: 'A Starbucks clone built with React JS.',
  //   imgUrl: images.about04,
  //   tags: ['Web App', 'ReactJS', 'UI/UX', 'Javascript'],
  // },
  {
    id: 'work-10',
    title: 'Blog Website',
    description: 'A blog website built with React JS.',
    imgUrl: images.about03,
    tags: ['Web App', 'ReactJS', 'UI/UX', 'Javascript'],
  },
];

const Work = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1});
  // const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState(works);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{y: 100, opacity: 0}]);

    setTimeout(() => {
      setAnimateCard([{y:0, opacity: 1}]);

      if(item === 'All'){
        setFilterWork(works);
      }
      else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500)
  }

  // useEffect(() => {
  //   const query = '*[_type == "works"]';
  //   client.fetch(query)
  //     .then((data) => {
  //       setWorks(data);
  //       setFilterWork(data);
  //     })
  // }, [])
  

  return (
    <>
      <h2 className="head-text">
        My creative <span>Portfolio</span> Section
      </h2>

      <div className="app__work-filter">
        {['UI/UX', 'Web App', 'Mobile App', 'ReactJS', 'All'].map((item, index) => (
          <div key={index} onClick={() => handleWorkFilter(item)} className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : '' }`}>
            {item}
          </div>  
        ))}
      </div>
      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work, index) => (
          <div className="app__work-item app__flex" key={index}>
            <div
              className="app__work-img app__flex"
            >
              {/* <img src={urlFor(work.imgUrl)} alt={work.name} /> */}
              <img src={work.imgUrl} alt={work.name} />

              {/* <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5 }}
                className="app__work-hover app__flex"
              >
                <a href={work.projectLink} target="_blank" rel="noreferrer">

                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.90] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                <a href={work.codeLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.90] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div> */}
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.title}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>{work.description}</p>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  )
}

export default AppWrap(Work, 'work');